import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import {onReactionError} from 'mobx';

import {MOBILE_MAX_SCREEN_SIZE} from 'base/search.js';
import autobind from 'common/decorators/autobind.js';
import {TRUE_STR} from 'core/constants.js';
import FocusManager from 'core/components/FocusManager.js';
import {DirectoryStoreContext} from 'core/stores/RootStore.js';
import BannerAdsList from 'directory/components/BannerAdsList.js';
import HealthFundDisclaimer from 'directory/components/HealthFundDisclaimer.js';
import DirectoryHeader from 'directory/components/DirectoryHeader.js';
import HealthFundInfo from 'directory/components/HealthFundInfo.js';
import SearchResults from 'directory/components/SearchResults.js';
import events from 'events.js';
import {captureException} from 'capture_sentry_exception.js';
import {snakeToCamelObjectKeys} from 'utils/case_converter.js';

require('intersection-observer');

export default class DirectoryApp extends React.Component {
    static contextType = DirectoryStoreContext;

    static propTypes = {
        adData: PropTypes.object,
        interest: PropTypes.object,
        locality: PropTypes.object,
        promotedGapSchemes: PropTypes.arrayOf(
            PropTypes.shape({
                healthFundId: PropTypes.number,
                gapSchemeId: PropTypes.number,
            }),
        ),
        specialty: PropTypes.object.isRequired,
        telehealthDirectory: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        onReactionError(captureException);
        this.mobileMediaQuery = window.matchMedia(
            `screen and (max-width: ${MOBILE_MAX_SCREEN_SIZE})`,
        );
    }

    componentDidMount() {
        const {
            adData,
            locality,
            promotedGapSchemes,
            specialty,
            interest,
            state,
            telehealthDirectory,
            enableDirectoryF2fFilter
        } = this.props;
        this.context.updateStore({
            locality,
            specialty,
            interest,
            adData,
            state,
            enableDirectoryF2fFilter,
            telehealthDirectory: !!telehealthDirectory, // force to be boolean
            showNextAvailableGp: !!this.props.showNextAvailableGp,
        });
        this.context.rootStore.healthFundStore.updateStore({
            promotedGapSchemes,
        });
        this.onWindowResize();
        events.listen(window, ['resize', 'orientationchange'], () => {
            this.onWindowResize();
        });
    }

    componentWillUnmount() {
        events.unlisten(window, ['resize', 'orientationchange'], () => {
            this.onWindowResize();
        });
    }

    @autobind
    onWindowResize(event) {
        this.context.updateStore({
            isMobile: window.matchMedia(
                `(max-width: ${MOBILE_MAX_SCREEN_SIZE})`,
            ).matches,
        });
    }

    render() {
        return (
            <>
                <FocusManager />
                <DirectoryHeader 
                    telehealthDirectory={this.props?.telehealthDirectory}
                    offersTelehealth={this.props?.specialty?.offersTelehealth}
                />
                <div className="result-list">
                    <HealthFundInfo />
                    <HealthFundDisclaimer main={true} />
                    <BannerAdsList forHealthFund={true} />
                    <HealthFundDisclaimer />
                    <BannerAdsList />
                    <SearchResults />
                </div>
            </>
        );
    }
}

(async function () {
    await events.ready();

    const directorySection = document.querySelector('#directory');
    const parsed = snakeToCamelObjectKeys(
        JSON.parse(directorySection.dataset.directory),
    );

    const props = {
        ...parsed,
        showNextAvailableGp: parsed.showNextAvailableGp === TRUE_STR,
    };

    ReactDOM.render(<DirectoryApp {...props} />, directorySection);
})();
